/** Shown while a page's code is downloading (pages load on demand, see router.tsx). */
const PageLoader = () => (
  <div className="min-h-[60vh] flex items-center justify-center" role="status" aria-label="Loading">
    <span className="w-9 h-9 rounded-full border-4 border-[#009fe3]/20 border-t-[#009fe3] animate-spin" />
  </div>
);

export default PageLoader;
